module.exports = require('./VerticalMovieRow');
